var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: false
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 27.081C54 12.124 41.913 0 27 0 12.088 0 0 12.125 0 27.081c0 14.957 12.088 27.082 27 27.082 14.913 0 27-12.124 27-27.082Zm-3.857 0c0 12.82-10.36 23.213-23.143 23.213-12.781 0-23.143-10.393-23.143-23.213S14.22 3.87 27 3.87c12.783 0 23.143 10.392 23.143 23.212Zm-11.797-8.21a2.246 2.246 0 0 0 0-3.17 2.23 2.23 0 0 0-3.16 0L27 23.912l-8.186-8.21a2.23 2.23 0 0 0-3.16 0 2.246 2.246 0 0 0 0 3.17l8.186 8.21-8.185 8.21a2.246 2.246 0 0 0 0 3.17 2.23 2.23 0 0 0 3.16 0L27 30.251l8.185 8.21a2.23 2.23 0 0 0 3.16 0 2.246 2.246 0 0 0 0-3.17l-8.185-8.21 8.186-8.21Z",
    fill: "currentColor"
  })));
};
export { SvgError as ReactComponent };
export default __webpack_public_path__ + "ea4d9cf2abfa493f031f39114268be62.svg";